import { render, staticRenderFns } from "./CadastroTetoAtendimento.vue?vue&type=template&id=f3d102f8&"
import script from "./CadastroTetoAtendimento.vue?vue&type=script&lang=js&"
export * from "./CadastroTetoAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports